export default class NullFilehandle {
    read() {
        throw new Error('never called');
    }
    stat() {
        throw new Error('never called');
    }
    readFile() {
        throw new Error('never called');
    }
    close() {
        throw new Error('never called');
    }
}
//# sourceMappingURL=nullFilehandle.js.map